import constants from "../utils/constants";
import Cookies from "universal-cookie";

let inMemoryStorage = {};


const cookies = new Cookies(null, { path: '/' });

const isSupported = () => {
  try {
    let x = cookies.get(ITEMS.test);
    return true;
  } catch (e) {
    console.error("problem in cookiejar isSupported", e)
    return false;
  }
};

const clear = () => {
  if (isSupported()) {
    document.cookie.replace(
        /(?<=^|;).+?(?=\=|;|$)/g,
        name => window.location.hostname
            .split(/\.(?=[^\.]+\.)/)
            .reduceRight((acc, val, i, arr) => i ? arr[i]='.'+val+acc : (arr[i]='', arr), '')
            .map(domain => document.cookie=`${name}=;max-age=0;path=/;domain=${domain}`)
    );
  } else {
    inMemoryStorage = {};
  }
};

const getItem = (key) => {
  if (isSupported()) {
    const item = cookies.get(key);
    return item;
  }
  else if (inMemoryStorage.hasOwnProperty(key)) return inMemoryStorage[key];
  else return null;
};

const removeItem = (key) => {
  if (isSupported()) {
    cookies.remove(key, { path: '/' });
  }
  else delete inMemoryStorage[key];
};

const setItem = (key, value) => {
  if (isSupported())  {
    cookies.set(key, value);
  }
  else inMemoryStorage[key] = value;
}

const ITEMS = {
  adminCurrentUser: "adminCurrentUser",
  adminToken: `adminToken`,
  currentUser: "currentUser",
  token: `token`,
  systemTenants: 'systemTenants',
  theme: 'tenantTheme',
  subdomain: 'subdomain',
  activeSystemTenantId: 'activeSystemTenantId',
  activeSystemTenant: 'activeSystemTenant',
  impersonating: 'impersonating',
  test: 'test',
  // storageJWT: `storage-${constants.APP_NAME}-jwt`,
  // username: `${constants.APP_NAME}-username`,
  // storageCurrentUser: "storageCurrentUser",
  // jwt: `${constants.APP_NAME}-jwt`,
}

const cookieJar = {
  clear,
  getItem,
  removeItem,
  setItem,
  ITEMS,
}

export default cookieJar;